import axios, { AxiosInstance } from "axios";
import getEnv from "@/core/utils/env";
import { ICDUserDto, ICDOrganisationDto, IUserOrganisationDto } from "@/core/models/CDIdentityModels";

export default interface IDiscoveryService {
  getUserOrganisations(userId: string): Promise<IUserOrganisationDto[]>;
  getOrganisation(organisationId: string): Promise<ICDOrganisationDto>;
}

class DiscoveryService implements IDiscoveryService {
  private static _instance: DiscoveryService;
  private readonly client: AxiosInstance;

  private constructor() {
    this.client = axios.create({
      baseURL: getEnv("VUE_APP_IDENTITY_DISCOVERY_URL"),
      headers: { "Content-Type": "application/json" }
    });
  }

  public static get Instance() {
    // Do you need arguments? Make it a regular static method instead.
    return this._instance || (this._instance = new this());
  }

  async getUser(userId: string): Promise<ICDUserDto> {
    const response = await this.client.get("api/get-user", {
      params: {
        code: getEnv("VUE_APP_IDENTITY_DISCOVERY_CODE"),
        userId: userId
      }
    });

    return response.data.user as ICDUserDto;
  }

  async getUserProfilePicture(userId: string): Promise<{ data: ArrayBuffer; contentType: string }> {
    const response = await this.client.get("api/get-user-profile-picture", {
      params: {
        code: getEnv("VUE_APP_IDENTITY_DISCOVERY_CODE"),
        userId: userId
      },
      responseType: "arraybuffer"
    });
    if (!(response.status >= 200 && response.status < 300)) {
      return { data: new ArrayBuffer(0), contentType: "" };
    }
    const contentType = response.headers["content-type"] || "";
    return { data: response.data, contentType };
  }

  async getOrganisation(organisationId: string): Promise<ICDOrganisationDto> {
    const response = await this.client.get("api/get-organisation", {
      params: {
        code: getEnv("VUE_APP_IDENTITY_DISCOVERY_CODE"),
        organisationId: organisationId
      }
    });

    return response.data.organisation as ICDOrganisationDto;
  }

  async getUserOrganisations(userId: string): Promise<IUserOrganisationDto[]> {
    const response = await this.client.get("api/get-user-organisations", {
      params: {
        code: getEnv("VUE_APP_IDENTITY_DISCOVERY_CODE"),
        userId: userId
      }
    });

    return response.data.organisations as IUserOrganisationDto[];
  }
}

export const discoveryService = DiscoveryService.Instance;
